module.exports = __webpack_public_path__ + "07_long_brown.b9306432.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/female/layer5/07_long_brown.png
// module id = mzQN
// module chunks = 0